<template>
  <pageQueryTopSearchTable
    class="page-query-top-search-table-double"
    :class="{ 'page-query-top-search-table-double-row': direction === 'row' }"
    v-bind="$attrs"
    :rowChange="rowChange"
    :cellChange="cellChange"
    :pagerCount="direction === 'row' ? 5 : 7"
    :pageLayout="direction === 'row' ? 'total, prev, pager, next, sizes' : undefined"
    :getTopDataHook="getTopDataHook"
    :rowShortcutNum="topRowShortcutNum"
    :rowButtonOnlyIcon="rowButtonOnlyIcon"
    :buttonColumnWidth="topButtonColumnWidth"
    :requestRowKeyByTop="requestRowKeyByTop"
  >
    <template #double>
      <div class="page-query-top-search-table-double-table" :style="{ flex: bottomTableSize }">
        <PgTable
          class="pg-page-query-table"
          ref="tableRef"
          height="auto"
          autoResize
          :rowShortcutNum="bottomRowShortcutNum"
          :rowButtonOnlyIcon="rowButtonOnlyIcon"
          :buttonColumnWidth="bottomButtonColumnWidth"
          :showOverflow="bottomShowOverflow"
          :loading="loading"
          :rowConfig="bottomRowConfig"
          :editConfig="bottomEditConfig"
          :columnTableCode="bottomColumnTableCode"
          :buttonRow="bottomRowMenuLead"
          :seachKeys="seachKeys"
          :seachMethod="seachMethod"
          :seachPlaceholder="bottomSeachPlaceholder"
        ></PgTable>
        <div class="pg-page-query__page">
          <div class="pg-page-query__page-left"></div>
          <PgPagination
            class="pg-page-query__page-right"
            :total="totalCount"
            :pageSize="page.pageSize"
            :pageSizes="bottomPageSizes"
            :current-page="page.pageNo"
            @size-change="sizeChange"
            @current-change="currentChange"
            :pager-count="direction === 'row' ? 5 : 7"
            :layout="
              direction === 'row'
                ? 'total, prev, pager, next, sizes'
                : 'total, prev, pager, next, sizes, jumper'
            "
          />
        </div>
      </div>
    </template>
  </pageQueryTopSearchTable>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import pageQueryTopSearchTable from './page-query-top-search-table.vue'
import { PgTable } from '../../table/index'
import { PgPagination } from '../../pagination/index'
import { ref, shallowRef, onDeactivated } from 'vue'
import { post, getValueByPath, setValueByPath } from '../../../utils/index'

const props = defineProps({
  bottomColumnTableCode: String,
  // 底部表格-分页条数[10, 20,...]
  bottomPageSizes: Array,
  // 底部表格-默认显示条数
  bottomPageSize: {
    type: Number,
    default: 30,
  },
  bottomRowConfig: Object,
  bottomEditConfig: Object,
  // 底部表格-数据请求url
  bottomDataUrl: String,
  bottomDataParameters: Object,
  // 高级查询的code
  bottomCriteriaCode: String,
  requestRowKey: {
    type: String,
    default: 'id',
  },
  requestRowKeyByTop: {
    type: String,
    default: 'id',
  },
  //获取行参数，默认值 {id: row.id}
  rowParameter: Function,
  seachKeys: {
    type: Array,
    default: () => ['goodsDetail.code'],
  },
  bottomSeachPlaceholder: {
    type: String,
    default: '商品',
  },
  bottomKeyword: String,
  bottomRowMenuLead: {
    type: String,
    default: 'BOTTOMROW',
  },
  // 从表是否受查询条件控制
  queryShare: Boolean,
  //上表查询时下表也触发查询的类型 init/seach/pageSize/pageNo/sort/column
  topQueryTrigger: {
    type: Array,
    default: () => ['init', 'seach'],
  },
  // 下表占用空间相对与商品占用空间倍数，默认1
  bottomTableSize: {
    type: Number,
    default: 1,
  },
  // 双表格排列方向： column/row
  direction: {
    type: String,
    default: 'column',
  },
  topRowShortcutNum: Number,
  bottomRowShortcutNum: Number,
  rowButtonOnlyIcon: Boolean,
  topButtonColumnWidth: [String, Number],
  bottomButtonColumnWidth: [String, Number],
  bottomShowOverflow: {
    type: [Boolean, String],
    default: true,
  },
})

const tableRef = ref(null)
const loading = ref(false)
const totalCount = ref(0)
const page = ref({
  pageNo: 1,
  pageSize: props.bottomPageSize,
  tableCode: props.bottomColumnTableCode,
})
const bottomData = shallowRef([])
const getData = async (keyword) => {
  if (!page.value.parameters && !props.queryShare) {
    return
  }
  const param = Object.assign(
    { criteriaCode: props.bottomCriteriaCode },
    page.value,
    props.bottomDataParameters
  )
  param.parameters = Object.assign(
    {},
    page.value.parameters,
    topParameters,
    props.bottomDataParameters?.parameters
  )
  if (props.bottomKeyword) {
    setValueByPath(param, props.bottomKeyword, keyword)
  } else {
    param.keyword = keyword
  }
  loading.value = true
  const [res] = await post(props.bottomDataUrl, param)
  loading.value = false
  if (res) {
    bottomData.value = res.data ?? [] // 避免返回null
    totalCount.value = res.totalCount ?? 0 // 赋值数据总数量
    // 调用表格异步数据处理方法
    tableRef.value?.loadDataAsync?.(() => res)
  }
}

let topParameters = null
const getTopDataHook = ({ parameters, type }) => {
  if (props.queryShare && props.topQueryTrigger.includes(type)) {
    topParameters = parameters?.parameters
    getData()
  }
}
// 分页-每页显示n条变化时出发
const sizeChange = (val) => {
  page.value.pageSize = val // 重新设置pageSiz
  page.value.pageNo = 1
  getData()
}
// 分页-页码变化时触发
const currentChange = (val) => {
  page.value.pageNo = val
  getData() // 按照新页码数据请求
}
const seachMethod = (keyword) => {
  page.value.pageNo = 1
  getData(keyword)
}
const rowChange = props.queryShare
  ? undefined
  : ({ row }) => {
      page.value.pageNo = 1
      page.value.parameters = props.rowParameter?.(row) ?? {
        [props.requestRowKey]: getValueByPath(row, props.requestRowKeyByTop),
      }
      getData()
    }
const cellChange = !props.queryShare
  ? undefined
  : ({ row, parameters }) => {
      topParameters = parameters?.parameters
      page.value.pageNo = 1
      page.value.parameters = props.rowParameter?.(row) ?? {
        [props.requestRowKey]: getValueByPath(row, props.requestRowKeyByTop),
      }
      getData()
    }

// onDeactivated(() => {
//   // 解决由于数据量大时并且滚动之后导致表格数据都被vue 监听在缓存时占用空间大
//   tableRef.value = JSON.parse(JSON.stringify(bottomData.value))
//   tableRef.value?.clearOb?.(bottomData.value)
// })
onDeactivated(() => {
  tableRef.value?.scrollTo(0, 0)
})
</script>
<style lang="scss">
@import '../style/page-query-top-search-table-double.scss';
</style>
